module.exports = __webpack_public_path__ + "img/返校_2.56831465.jpg";